// src/components/strumenti/SostituzioneLed.js — W442. Risparmio e rientro della sostituzione con LED
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, euro, fmt } from "./UiStrumento";
import { sostituzioneLed } from "../../utils/calcoliStrumenti";

export default function SostituzioneLed() {
  const { v, set, n, azzera } = useCampi({ num:"", wv:"", wn:"", ore:"", prezzo:"", costo:"" });
  const r = sostituzioneLed(n("num"), n("wv"), n("wn"), n("ore"), n("prezzo"), n("costo"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Numero di apparecchi" valore={v.num} onChange={set("num")} placeholder="Es. 20"/>
        <Campo etichetta="Ore di accensione all'anno" valore={v.ore} onChange={set("ore")} placeholder="Es. 2500"/>
        <Campo etichetta="Potenza attuale per apparecchio (W)" valore={v.wv} onChange={set("wv")} placeholder="Es. 58" aiuto="Comprese le perdite dell'alimentatore."/>
        <Campo etichetta="Potenza LED per apparecchio (W)" valore={v.wn} onChange={set("wn")} placeholder="Es. 22"/>
        <Campo etichetta="Prezzo energia (€/kWh)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 0,25"/>
        <Campo etichetta="Costo per apparecchio installato (€, facoltativo)" valore={v.costo} onChange={set("costo")} placeholder="Es. 40"/>
      </Griglia>
      {n("wn") >= n("wv") && n("wv") > 0 && <Avviso>La potenza LED deve essere più bassa di quella attuale.</Avviso>}
      <Risultato settore="illuminazione" titolo="Energia risparmiata" valore={fmt(r?.kwhAnno, 0)} unita="kWh/anno"
        righe={r ? [["Riduzione dei consumi", fmt(r.riduzionePct, 1) + "%"], r.euroAnno !== null && ["Risparmio annuo", euro(r.euroAnno)], r.spesa !== null && ["Spesa", euro(r.spesa)], r.rientroAnni !== null && ["Rientro", fmt(r.rientroAnni, 1) + " anni"]] : []}/>
      <Formula>kWh/anno = n × (W attuali − W LED) ÷ 1000 × ore; risparmio = kWh × €/kWh; rientro = spesa ÷ risparmio annuo. Non considera la minore manutenzione né eventuali incentivi. Verifica che il flusso luminoso dei LED sia adeguato.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
